"use strict";
var core_1 = require('@angular/core');
var MapsAPILoader = (function () {
    function MapsAPILoader() {
    }
    MapsAPILoader.decorators = [
        { type: core_1.Injectable },
    ];
    /** @nocollapse */
    MapsAPILoader.ctorParameters = function () { return []; };
    return MapsAPILoader;
}());
exports.MapsAPILoader = MapsAPILoader;
//# sourceMappingURL=maps-api-loader.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-google-maps/core/services/maps-api-loader/maps-api-loader.js
// module id = 117
// module chunks = 33